import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api from '../utils/api';
import { toast } from 'react-toastify';

export const getAllwizardOrderThunk = createAsyncThunk(
    'wizard/getAllwizardOrderThunk',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getAllwizardOrder(config);
            //   console.log("nnnnn",response.data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const getwizardOrderStatisticsThunk = createAsyncThunk(
    'wizard/getwizardOrderStatisticsThunk',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getwizardOrderStatisticsdata(config);
              console.log("staticssssssss",response.data?.data);
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const wizardOrderDetailsThunk = createAsyncThunk(
    'wizard/wizardOrderDetailsThunk',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.getwizardOrderDetails(id);
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const exportwizardOrderThunk = createAsyncThunk(
    'order/exportwizardOrderThunk',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getAllwizardOrder(config);
              console.log(response.data?.data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const deletewizardOrderThunk = createAsyncThunk(
    'order/deletewizardOrderThunk',
    async (id, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.deletewizardOrder(id?.id ?? id, id?.password);
            dispatch(setwizardOrderrefresh())
            toast.success('wizard enquiry deleted successfully')
            return response.data?.data;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'unable to delete wizard enquiry')
        }
    }
);


export const updateOrderStatus = createAsyncThunk(
    'order/updateStatus',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.updatewizardOrderStatus(data);
            dispatch(setwizardOrderrefresh())
            toast.success('order updated  successfully')
            return response.status;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'unable to update order')
        }
    }
);

const wizardOrderSlice = createSlice({
    name: 'wizardOrder',
    initialState: {
        wizard: [],
        orderDetails: {},
        orderStatistics: {
            data: {},
            loading: false
        },
        refresh: false,
        loading: false,
        exportLoading: false,
        error: null,
        selectedTab: 0,
        page: 1,
        search: '',
        status: '',
        fromDate: '',
        toDate: '',
    },
    reducers: {

        setwizardOrderrefresh: (state, action) => {
            state.refresh = !state.refresh;
        },
        setwizardOrderPage: (state, action) => {
            state.page = action.payload
        },
        setwizardOrderSearch: (state, action) => {
            state.search = action.payload
        },
        setwizardOrderStatus: (state, action) => {
            state.status = action.payload
        },
        setwizardOrderFromDate: (state, action) => {
            state.fromDate = action.payload
        },
        setwizardOrderToDate: (state, action) => {
            state.toDate = action.payload
        },
        setwizardOrderSelectedTab: (state, action) => {
            state.selectedTab = action.payload
        },
        setwizardOrderData: (state, action) => {
            state.orderDetails = {
                ...state.orderDetails, // Keep existing fields
                products: action.payload, // Update only products
            };
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllwizardOrderThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllwizardOrderThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.wizard = action.payload;
            })
            .addCase(getAllwizardOrderThunk.rejected, (state, action) => {
                state.loading = false;
            })

            //details
            .addCase(wizardOrderDetailsThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(wizardOrderDetailsThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.orderDetails = action.payload;
            })
            .addCase(wizardOrderDetailsThunk.rejected, (state, action) => {
                state.loading = false;
            })

            //details
            .addCase(exportwizardOrderThunk.pending, (state) => {
                state.exportLoading = true;
            })
            .addCase(exportwizardOrderThunk.fulfilled, (state, action) => {
                state.exportLoading = false;
            })
            .addCase(exportwizardOrderThunk.rejected, (state, action) => {
                state.exportLoading = false;
            })

            //statistics
            .addCase(getwizardOrderStatisticsThunk.pending, (state) => {
                state.orderStatistics.loading = true;
            })
            .addCase(getwizardOrderStatisticsThunk.fulfilled, (state, action) => {
                state.orderStatistics.loading = false;
                state.orderStatistics.data = action.payload
            })
            .addCase(getwizardOrderStatisticsThunk.rejected, (state, action) => {
                state.orderStatistics.loading = false
            })
    },
});

export const { setwizardOrderrefresh, setwizardOrderPage, setwizardOrderSearch, setwizardOrderStatus, setwizardOrderFromDate, setwizardOrderToDate, setwizardOrderSelectedTab, setwizardOrderData } = wizardOrderSlice.actions
export default wizardOrderSlice.reducer;

